export default __webpack_public_path__ + "static/media/Becherwerke.9a679e56.jpg";